// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-meA","type":"styles_type__Nejp0","choices":"styles_choices__Fi5wq"};